import { render, staticRenderFns } from "./PropTopPosts.vue?vue&type=template&id=bad044b6&scoped=true&"
import script from "./PropTopPosts.vue?vue&type=script&lang=js&"
export * from "./PropTopPosts.vue?vue&type=script&lang=js&"
import style0 from "./PropTopPosts.vue?vue&type=style&index=0&id=bad044b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad044b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
installComponents(component, {VCarousel,VCarouselItem})
